import { render } from "./SettingsAlert.vue?vue&type=template&id=03614bac&scoped=true"
import script from "./SettingsAlert.vue?vue&type=script&lang=js"
export * from "./SettingsAlert.vue?vue&type=script&lang=js"

import "./SettingsAlert.vue?vue&type=style&index=0&id=03614bac&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03614bac"]])

export default __exports__